var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    directives: [
      {
        name: "show",
        rawName: "v-show",
        value: !_vm.emptyGeolocation,
        expression: "!emptyGeolocation",
      },
    ],
    ref: "mapElement",
    staticClass: "map-wrapper",
    attrs: { id: _vm.mapId },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }